import { observer } from 'mobx-react'
import React from 'react'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { GoogleMapsIcon } from '@flowwai-frontend/design-system/icons'
import { LocationValue } from '@flowwai-frontend/shared/common-components'

import { MapCoordinates } from '../../../types'
import { redirectToGoogleMapsWithCenterMarked } from '../../../utils'
import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import OpenInGMapsPopover from '../../OpenInGMapsPopover/OpenInGMapsPopover'

interface Props {
   geoShape: LocationValue
}

const OpenInGoogleMapsTool = (props: Props): React.ReactElement => {
   const { geoShape } = props

   const hasCoordinates =
      geoShape.value instanceof Array
         ? geoShape.value.length > 0
         : geoShape.value

   const { mapsT } = useMapsUtilityContext()

   const onClickOpenInGMaps = (): void => {
      const coordinates: MapCoordinates[] | MapCoordinates =
         geoShape.value ?? []

      redirectToGoogleMapsWithCenterMarked(coordinates, 22, true)
   }

   return (
      <OpenInGMapsPopover t={mapsT} place='top'>
         <Button
            size={'Small'}
            hierarchy={Hierarchy.Tertiary}
            subVariant={SubVariant.Gray}
            className={'w-fit !rounded-xl shrink-0 hover:bg-gray-100'}
            onClick={onClickOpenInGMaps}
            leftIcon={() => <GoogleMapsIcon />}
            isDisabled={!hasCoordinates}
         >
            {mapsT('openInGMaps')}
         </Button>
      </OpenInGMapsPopover>
   )
}

export default observer(OpenInGoogleMapsTool)
